export default "../d0f08c38a525b46417cc65401323ff95.jpg";